module.exports = __webpack_public_path__ + "img/WMeisterC.9b45f16c.png";